import { TrialProBadgeWithTooltip } from "@clockwise/web-commons/src/ui/trial-pro-badge-with-tooltip";
import React from "react";

export const MonetizationBadge = () => {
  return (
    <span className="cw-mx-4 cw-flex cw-items-center">
      <TrialProBadgeWithTooltip showToolTip={false} badgeText="Teams" colorOption="green" />
    </span>
  );
};
